import React from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';

const HeaderFiltrosBorrado = ({
    estatusBorrado,
    handleCambiarEstatusBorrado,
    tipoLicencia,
    handleCambiarTipoLicencia,
    mesesVencimiento,
    handleCambiarMeses,
    cargando,
    children
}) => (
    <Card className="mb-3">
        <Card.Body>
            <Row className="align-items-center mb-3">
                <Col>
                    <h5 className="mb-0 text-primary fw-bold">
                        <i className="fas fa-trash-alt me-2"></i>
                        Mantenimiento: Borrado de Licencias
                    </h5>
                    <p className="fs--1 text-600 mb-0 mt-1">
                        Consulta y programa la eliminación de licencias vencidas de empresas inactivas.
                    </p>
                </Col>
            </Row>

            <Row className="align-items-center g-3">
                <Col md="auto" className="d-flex flex-wrap align-items-center gap-2">
                    <div className="nav-group border-0 bg-transparent p-0">
                        <button
                            className={`btn btn-sm ${estatusBorrado === 0 ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => handleCambiarEstatusBorrado(0)}
                            disabled={cargando}
                        >
                            Pendientes por Programar
                        </button>
                        <button
                            className={`btn btn-sm ms-2 ${estatusBorrado === 1 ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => handleCambiarEstatusBorrado(1)}
                            disabled={cargando}
                        >
                            Ya Programadas
                        </button>
                    </div>
                    {children && (
                        <div className="d-flex align-items-center gap-2 ms-md-3 mt-2 mt-md-0">
                            {children}
                        </div>
                    )}
                </Col>

                <Col md>
                    <div className="d-flex justify-content-md-end gap-3 flex-wrap">
                        <div className="d-flex align-items-center gap-1">
                            <span className="fs--1 text-700 fw-semi-bold text-nowrap">Licencia:</span>
                            <Form.Select
                                size="sm"
                                style={{ width: 'auto', minWidth: '160px' }}
                                value={tipoLicencia}
                                onChange={handleCambiarTipoLicencia}
                            >
                                <option value="Todos">Todas las Licencias</option>
                                <option value="Nube">Solo Nube</option>
                                <option value="AkasiaPOS">Solo AkasiaPOS</option>
                                <option value="Ambas">Empresas con Ambas</option>
                            </Form.Select>
                        </div>
                        <div className="d-flex align-items-center gap-1">
                            <span className="fs--1 text-700 fw-semi-bold text-nowrap">Vencimiento:</span>
                            <Form.Select
                                size="sm"
                                style={{ width: 'auto', minWidth: '160px' }}
                                value={mesesVencimiento}
                                onChange={handleCambiarMeses}
                            >
                                <option value={-3}>&lt; 3 Meses Vencida</option>
                                <option value={1}>&ge; 1 Mes Vencida</option>
                                <option value={2}>&ge; 2 Meses Vencida</option>
                                <option value={3}>&ge; 3 Meses Vencida</option>
                                <option value={6}>&ge; 6 Meses Vencida</option>
                                <option value={12}>&ge; 12 Meses Vencida</option>
                            </Form.Select>
                        </div>
                    </div>
                </Col>
            </Row>
        </Card.Body>
    </Card>
);

export default HeaderFiltrosBorrado;
